import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { ensureSession, fetchCurrentSessionUser, logoutCurrentUser } from '../services/api';

const AuthContext = createContext({
  user: null,
  isAdmin: false,
  loading: true,
  refreshUser: () => {},
  logout: async () => {}
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const { user: sessionUser } = await fetchCurrentSessionUser();
      setUser(sessionUser);
    } catch (error) {
      console.error('Impossible de charger la session utilisateur', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    ensureSession()
      .catch(() => {})
      .finally(() => {
        if (mounted) {
          loadUser();
        }
      });
    return () => {
      mounted = false;
    };
  }, [loadUser]);

  const handleLogout = useCallback(async () => {
    await logoutCurrentUser().catch(() => {});
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAdmin: user?.role === 'admin',
        loading,
        refreshUser: loadUser,
        logout: handleLogout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
